@if (timesheets && timesheets.length > 0) {
<div class="row justify-content-end mb-2">
  <div class="col-auto">
    <button
      type="button"
      class="btn btn-outline-primary"
      (click)="
        formatoDaMostrare !== 'ore'
          ? (formatoDaMostrare = 'ore')
          : (formatoDaMostrare = 'percentuale')
      "
    >
      Visualizza in {{ formatoDaMostrare !== "ore" ? "ore" : "percentuali" }}
    </button>
  </div>
  @if (formatoDaMostrare !== "ore") {
  <div class="col-12">
    <div class="mt-3 mb-2 ps-2 legenda-timesheet">
      <span class="me-4">
        <span class="legend-box td-bg-coincidenza"></span>
        % Coincidente
      </span>
      <span class="me-4">
        <span class="legend-box td-bg-modifica"></span>
        % Con rettifica
      </span>
      <span class="me-4">
        <span class="legend-box td-bg-trasferta"></span>
        Giornata di trasferta
      </span>
    </div>
  </div>
  }
</div>
<div class="d-flex mb-3 w-100 overflow-auto">
  <table
    class="table table-responsive table-hover table-bordered table-borderless"
  >
    <thead>
      <tr>
        <th
          class="table-column-max-width sticky-column"
          [colSpan]="!utenteRisorsa ? 2 : 1"
          scope="col"
        >
          {{ mapMesi[mese - 1] }} {{ anno }}
        </th>
        <th
          class="table-column-max-width"
          [colSpan]="lunghezzaTimesheet"
          scope="col"
        ></th>
      </tr>
      <tr>
        @if(!utenteRisorsa){

        <th
          class="table-column-max-width text-slate-800 sticky-column"
          scope="col"
          title="Risorsa"
        >
          <div class="d-flex align-items-center">
            Risorsa @if(!utenteRisorsa){

            <div class="ms-1 position-relative min-height-th-home">
              <!-- <i
                class="bi position-absolute top-0"
                [ngClass]="getCaretClass('o.Cognome, o.Nome', false)"
              ></i>
              <i
                class="bi position-absolute bottom-0"
                [ngClass]="getCaretClass('o.Cognome, o.Nome', true)"
              ></i> -->
            </div>
            }
          </div>
        </th>
        }

        <th
          class="table-column-max-width text-slate-800"
          [ngClass]="{
            'sticky-column-2': !utenteRisorsa,
            'sticky-column': utenteRisorsa
          }"
          role="button"
          (click)="sort('descrizioneCommessa')"
          scope="col"
          title="Commessa"
        >
          <div class="d-flex align-items-center">
            Commessa @if(!utenteRisorsa){

            <div class="ms-1 position-relative min-height-th-home">
              <i
                class="bi position-absolute top-0"
                [ngClass]="getCaretClass('descrizioneCommessa', false)"
              ></i>
              <i
                class="bi position-absolute bottom-0"
                [ngClass]="getCaretClass('descrizioneCommessa', true)"
              ></i>
            </div>
            }
          </div>
        </th>
        @for (giorno of [].constructor(lunghezzaTimesheet); let i = $index;
        track i) {
        <th
          class="table-column-max-width text-slate-800"
          style="min-width: 43px"
          scope="col"
          [title]="getNumeroGiorno(i) + ' ' + mapMesi[mese - 1] + ' ' + anno"
        >
          <div class="d-flex align-items-center justify-content-end">
            <div class="position-relative" style="height: 29px"></div>
            {{ getNumeroGiorno(i) }}
          </div>
        </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (element of timesheets; track $index) {
      @if((element.descrizioneCommessa && formatoDaMostrare === 'percentuale')
      || formatoDaMostrare === 'ore'){
      <tr>
        @if(!utenteRisorsa){
        <td class="table-column-max-width sticky-column">
          <!-- NOME RISORSA -->
          <span
            class="fw-semibold text-nowrap"
            [matTooltip]="element.nomeRisorsa"
          >
            {{ element.nomeRisorsa }}
          </span>

          <!-- MATRICOLA -->
          <br />
          <span class="text-slate-700 text-nowrap" [title]="element.risorsa"
            >{{ element.risorsa }}
          </span>
        </td>
        }
        <td
          class="table-column-max-width"
          [ngClass]="{
            'sticky-column-2': !utenteRisorsa,
            'sticky-column': utenteRisorsa
          }"
        >
          <!-- NOME COMMESSA -->
          <span
            class="fw-semibold text-nowrap"
            [matTooltip]="
              element.descrizioneCommessa
                ? element.descrizioneCommessa
                : element.tipologia
            "
          >
            {{ element?.descrizioneCommessa ?? element.tipologia }}
          </span>

          @if(element?.descrizioneCommessa && element.tipologia){
          <br />
          <!-- CODICE COMMESSA -->
          <span
            class="text-slate-700 text-nowrap"
            [matTooltip]="element.tipologia"
            >{{ element.tipologia }}
          </span>
          }
        </td>
        @for (ngiorno of [].constructor(lunghezzaTimesheet); let idx = $index;
        track idx) {
        <td
          class="table-column-max-width text-end align-items-center"
          style="min-width: 43px"
          [class.td-bg-coincidenza]="indiceGiorniCoincidenza.includes(idx)
            && getGiornoValue(element, idx) > 0
            && element.coincidenza
            && !indiceGiorniInTrasferta.includes(idx)"
          [class.td-bg-trasferta]="indiceGiorniInTrasferta.includes(idx)"
          [class.td-bg-modifica]="indiceGiorniModificati.includes(idx)
            && getGiornoValue(element, idx) > 0
            && commesseModificate.includes(element.tipologia)"
          >
          <span>
          {{
            formatoDaMostrare === "ore"
              ? getGiornoValue(element, idx)
              : (getGiornoValue(element, idx) * 100).toFixed(0)
          }}
          </span>
        </td>
        }
      </tr>
      } }
    </tbody>
  </table>
</div>
@if(!utenteRisorsa){

<div class="d-flex justify-content-between align-items-center">
  <span class="text-slate-700 ps-3 mb-3">
    {{
      elencoCount > 0
        ? elencoCount > 1
          ? elencoCount + " record trovati"
          : elencoCount + " record trovato"
        : ""
    }}
  </span>

  <pagination
    *ngIf="totalPages > 0"
    alignment="end"
    [currentPage]="currentPage"
    [pageNumbers]="totalPages"
    [currentChanger]="pageOffset"
    (changerEvent)="changerEvent($event)"
    (pageEvent)="getPage($event)"
  >
  </pagination>
</div>
} } @else {
<p class="w-100 text-center">Nessun timesheet trovato</p>
}
